import React, { Component } from 'react';
import { parseDate } from '../../utils/tools';
import './style.less';

export default class CourseDetailHeader extends Component {
    render(){
        const { title, stuCount, lessonDate, stuStatus, bg, isPermanent } = this.props;
        const curTime = new Date().getTime();
        const date = parseDate(lessonDate + 86399999);
        return(
            <div className="header_wrap" style={{backgroundImage:`url(${bg})`}}>
                <div className="shadow_wrap"></div>
                {title && <h3 className="title">{this.props.title}</h3>}
                {stuCount && <div className="text stu_count">{stuCount}</div>}
                {(stuStatus && (stuStatus !== 0) )&& <div className="text lesson_date">{lessonDate + 86399999 < curTime ? `已于${date}到期` : isPermanent ? '永久有效' : `有效期至 ${date}`}</div>}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/template/CourseDetailHeader/CourseDetailHeader.jsx